// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeSunbit_titleIcon__6tpQd","inputPhoneContainer":"ViewChargeSunbit_inputPhoneContainer__sbU6d"};